import { get, post, type ApiResponse } from '@/utils/request';

/** 管理员登录 POST /api/admin/login */
export async function adminLogin(
    body: {
        username: string;
        password: string;
    },
    options?: { skipErrorHandler?: boolean },
): Promise<ApiResponse<API.AdminLoginResponse>> {
    return post<API.AdminLoginResponse>('/api/admin/login', body, options);
}

/** 获取当前管理员信息 GET /api/admin/info */
export async function getAdminInfo(
    options?: { skipErrorHandler?: boolean },
): Promise<ApiResponse<API.AdminInfo>> {
    return get<API.AdminInfo>('/api/admin/info', undefined, options);
}

/** 刷新 Token POST /api/admin/refresh */
export async function refreshToken(
    body: {
        refreshToken: string;
    },
    options?: { skipErrorHandler?: boolean },
): Promise<ApiResponse<API.AdminLoginResponse>> {
    return post<API.AdminLoginResponse>('/api/admin/refresh', body, options);
}

/** 管理员登出 POST /api/admin/logout */
export async function adminLogout(
    options?: { skipErrorHandler?: boolean },
): Promise<ApiResponse<unknown>> {
    return post<unknown>('/api/admin/logout', undefined, options);
}
